import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters } from "./config";

const CustomerList = () => {

  return (
    <Table tableId="contact_groups" title="Contact Group" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="name" idKey="contact_group_id" fieldsToSearch={["Name", "Email", "Phone"]} trash={false} />
  );
};

export default CustomerList;